import { ref } from 'vue';
import { useLockResource } from '@/core/composables/useLockResource';
import {
  type GetTariffScheduleGridQuery,
  type UpdateTariffGridMutationVariables,
  useCancelTariffGridEditMutation,
  useGetTariffScheduleGridQuery,
  useKeepAliveTariffGridEditMutation,
  useStartTariffGridEditMutation,
  useUpdateTariffGridMutation,
} from '@/graphql/generated';

const tariffScheduleGrid = ref<GetTariffScheduleGridQuery['tariffScheduleGrid']>();

export const usePricesStore = () => {
  const getTariffScheduleGrid = async (tariffScheduleCid: string) => {
    const { request, data, response } = useGetTariffScheduleGridQuery({ tariffScheduleCid });

    await request();

    if (data.value) {
      tariffScheduleGrid.value = data.value.tariffScheduleGrid;
    }

    return response;
  };

  const editTariffGridStart = async (id: string) => {
    const { request, data } = useStartTariffGridEditMutation({ tariffScheduleCid: id });

    const response = await request();

    if (data.value) {
      tariffScheduleGrid.value = data.value.tariffGridEdit.Grid;
    }

    return response;
  };

  const editTariffGridKeepAlive = async (id: string) => {
    const { request } = useKeepAliveTariffGridEditMutation({ tariffScheduleCid: id });

    const response = await request();

    return response;
  };

  const editTariffGridCancel = async (id: string) => {
    const { request } = useCancelTariffGridEditMutation({ tariffScheduleCid: id });

    const response = await request();

    return response;
  };

  const editTariffGridUpdate = async (payload: UpdateTariffGridMutationVariables) => {
    const { request } = useUpdateTariffGridMutation(payload);

    const response = await request();

    if (response?.data?.tariffGridUpdate?.Grid) {
      tariffScheduleGrid.value = response.data.tariffGridUpdate.Grid;
    }

    return response;
  };

  const {
    editResourceStart: editGridStart,
    editResourceCancel: editGridCancel,
    editResourceUpdate: editGridUpdate,
    isEditResourceStartLoading: isEditGridStartLoading,
    isEditResourceUpdateLoading: isEditGridUpdateLoading,
  } = useLockResource(
    'gridEdit',
    editTariffGridStart,
    editTariffGridKeepAlive,
    editTariffGridCancel,
    editTariffGridUpdate,
  );

  return {
    tariffScheduleGrid,
    getTariffScheduleGrid,
    editGridStart,
    editGridCancel,
    editGridUpdate,
    isEditGridStartLoading,
    isEditGridUpdateLoading,
  };
};
